<div class="content"
     [class]="position()"
     [style.--custom-arrow-left]="customArrowLeft() ? customArrowLeft() + '%' : ''"
     [innerHTML]="content() | newLineToHtml | safeHTML"></div>
